import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CadsMenuSectionConfig } from './cads-menu-section.config';

/**
 * **Container only:** titled (optional) card shell that groups projected menu rows—typically {@link CadsMenuRowItemComponent}
 * or {@link CadsAccountRowComponent}. Applies surface, border, radius, and shadow; inserts **1px** dividers between **direct**
 * projected children. Optional {@link CadsMenuSectionConfig.disabled} mutes the card only (non-interactive). Does not add
 * inner padding (rows own their padding). Projected content and tap behavior live in child components.
 */
@Component({
  selector: 'cads-menu-section',
  standalone: true,
  templateUrl: './cads-menu-section.component.html',
  styleUrl: './cads-menu-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsMenuSectionComponent {
  /** Section options; default empty (no title). */
  readonly config = input<CadsMenuSectionConfig>({});

  readonly _showTitle = computed(() => {
    const t = this.config().title?.trim();
    return !!t;
  });

  /** Trimmed title for display when {@link CadsMenuSectionComponent._showTitle} is true. */
  readonly _titleText = computed(() => this.config().title?.trim() ?? '');

  readonly _isDisabled = computed(() => this.config().disabled ?? false);
}
